import React, { useEffect, useState } from 'react';
import ImageDownloadable from './ImageDownloadable';

const unactiveStyle = {
    borderRadius: '4px',
    height: '80px',
    width: '120px',
    objectFit: 'cover'
}

const activeStyle = {
    border: '3px solid #56ADF3',
    borderRadius: '4px',
    height: '80px',
    width: '120px',
    objectFit: 'cover'
}

type ImageSelectableProps = {
    id: string
    type: string
    src: string
    preview?: boolean
    onClick?: () => void
    active?: string
}

export default function ImageSelectable(props: ImageSelectableProps) {
    const [selectedStyle, setSelectedStyle] = useState(unactiveStyle)

    useEffect (() => {
        if (props.src === props.id) {
            setSelectedStyle(activeStyle)
        } else {
            setSelectedStyle(unactiveStyle)
        }
    }, [props.src])

    return (
        <ImageDownloadable id={props.id} type={props.type} style={selectedStyle} preview={props.preview} onClick={props.onClick}/>
    )
}
